import { PublicGallery } from '@mtg/shared';
import { Link } from 'wouter';
import { api } from '../api.ts';
import { CardImage } from '../components/CardImage.tsx';
import { Pip } from '../components/ManaCost.tsx';
import { plural } from '../format.ts';
import { useApi } from '../useApi.ts';
import { PublicFooter } from './PublicDeckPage.tsx';

/** Every deck, read-only, for anyone at /decks while it's shared. Each tile opens the deck. */
export function GalleryPage() {
  const { data, error } = useApi(() => api('/api/public/gallery', PublicGallery), []);
  if (error) {
    return (
      <main className="main">
        <p className="error">{error}</p>
      </main>
    );
  }
  if (!data) return <main className="main muted">Loading…</main>;
  const count = data.sections.reduce((n, s) => n + s.decks.length, 0);
  return (
    <>
      <main className="main stack">
        <h1>Decks</h1>
        <p className="lead">{plural(count, 'deck')}</p>
        {data.sections.map((section) => (
          <section key={section.title ?? ''} className="stack gallery-section">
            {section.title && (
              <h2 className="gallery-heading">
                <span>{section.title}</span>
              </h2>
            )}
            <ul className="gallery">
              {section.decks.map((d) => (
                <li key={d.id}>
                  <Link href={`/decks/${d.id}`} className="gallery-tile">
                    <span className={`gallery-art${d.commanders.length > 1 ? ' partners' : ''}`}>
                      {d.commanders.length ? (
                        d.commanders.map((c) => <CardImage key={c.scryfallId} card={c} />)
                      ) : (
                        <span className="card-img placeholder">{d.name}</span>
                      )}
                    </span>
                    <span className="gallery-text">
                      <strong>{d.name}</strong>
                      {d.commanders.length > 0 && <span className="muted small">{d.commanders.map((c) => c.name).join(' & ')}</span>}
                      <span className="small gallery-meta">
                        <span className="mana" aria-label={`Colors: ${d.colorIdentity.join('') || 'colorless'}`}>
                          {(d.colorIdentity.length ? d.colorIdentity : ['C']).map((c) => (
                            <Pip key={c} symbol={c} />
                          ))}
                        </span>
                        {d.label && <span className="gallery-label">{d.label}</span>}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </main>
      <PublicFooter />
    </>
  );
}
